<template>
    <span class="px-3 inline-flex text-sm leading-5 font-semibold rounded-full" :class="classes">
        {{ titleCasedLabel | titleCase }}
    </span>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        }
    },

    computed: {
        titleCasedLabel: function() {
            return this.label.split('_').join(' ');
        },

        classes: function() {
            return {
                'bg-gray-200 text-gray-800': this.label === 'archived',
                'bg-blue-200 text-blue-800': this.label === 'draft',
                'bg-orange-200 text-orange-800': this.label === 'in_review',
                'bg-teal-200 text-teal-800': this.label === 'posted',
                'bg-indigo-200 text-indigo-800': this.label === 'in_progress',
                'bg-green-200 text-green-800': this.label === 'completed',
                'bg-red-200 text-red-800': this.label === 'rejected'
            };
        }
    }
};
</script>
